module.exports = __webpack_public_path__ + "static/media/feature-new-editor2.bda124c7.png";